// src/pages/Superadmin/MockTrainingPage.jsx
import React, { useState } from "react";
import NavSidebar from "../../components/Dashboard/Sidebar_Traing";
import ChatbotWidget from "../../components/chatbot/Chatbot_Training";
import "../../styles/MockTrainingPage.css";

export default function MockTrainingPage() {
    const [activeNav, setActiveNav] = useState("Mock Training");
    const [scenario, setScenario] = useState("");
    const [newCustomer, setNewCustomer] = useState("");
    const [showConversationSection, setShowConversationSection] = useState(true);
    const [showHistorySection, setShowHistorySection] = useState(true);
   
  
    const [trainingHistory] = useState([
      {
        scenario: "Laser Facial",
        customerType: "New",
        date: "2025-07-26",
        score: 3,
        status: "Passed",
      },
    ]);
  
    return (
      <div className="mock-training-container">
        {/* Sidebar */}
        <NavSidebar activeNav={activeNav} setActiveNav={setActiveNav} />
  
        {/* Main Content */}
        <div className="mock-training-main">
          {/* Title + Line */}
          <h1 className="mock-training-title">Mock Training</h1>
          <hr className="mock-training-line" />
  
          {/* New Conversation Section */}
          <div className="section-header">
            <button
              className="section-button"
              onClick={() => setShowConversationSection(!showConversationSection)}
            >
              New Conversation {showConversationSection ? "▼" : "▲"}
            </button>
          </div>
  
          {showConversationSection && (
            <>
                <div className="filter-section">
                <label>
                    Scenarios:
                    <select
                    value={scenario}
                    onChange={(e) => setScenario(e.target.value)}
                    >
                    <option value="">Select Scenario</option>

                    <optgroup label="General Consultation">
                        <option value="Initial Consultation – New Client">Initial Consultation – New Client</option>
                        <option value="Follow-Up Consultation – Returning Client">Follow-Up Consultation – Returning Client</option>
                        <option value="Virtual Consultation – Online Meeting">Virtual Consultation – Online Meeting</option>
                        <option value="Comparing Treatment Options">Comparing Treatment Options</option>
                    </optgroup>

                    <optgroup label="Skin Treatments">
                        <option value="Chemical Peel Consultation">Chemical Peel Consultation</option>
                        <option value="Microdermabrasion Inquiry">Microdermabrasion Inquiry</option>
                        <option value="Microneedling with PRP Consultation">Microneedling with PRP Consultation</option>
                        <option value="HydraFacial Consultation">HydraFacial Consultation</option>
                        <option value="Acne Treatment Inquiry">Acne Treatment Inquiry</option>
                        <option value="Pigmentation Treatment Consultation">Pigmentation Treatment Consultation</option>
                        <option value="Rosacea / Redness Management Consultation">Rosacea / Redness Management Consultation</option>
                        <option value="Skin Tightening Consultation (RF, Ultrasound)">Skin Tightening Consultation (RF, Ultrasound)</option>
                    </optgroup>

                    <optgroup label="Laser Treatments">
                        <option value="Laser Hair Removal – Face">Laser Hair Removal – Face</option>
                        <option value="Laser Hair Removal – Full Body">Laser Hair Removal – Full Body</option>
                        <option value="Laser Skin Resurfacing Consultation">Laser Skin Resurfacing Consultation</option>
                        <option value="Laser for Acne Scars Inquiry">Laser for Acne Scars Inquiry</option>
                        <option value="IPL Photofacial Consultation">IPL Photofacial Consultation</option>
                        <option value="Tattoo Removal Consultation">Tattoo Removal Consultation</option>
                    </optgroup>

                    <optgroup label="Injectables">
                        <option value="Botox for Forehead Lines Consultation">Botox for Forehead Lines Consultation</option>
                        <option value="Botox for Crow’s Feet Consultation">Botox for Crow’s Feet Consultation</option>
                        <option value="Botox for Masseter Reduction (Jaw Slimming)">Botox for Masseter Reduction (Jaw Slimming)</option>
                        <option value="Dermal Filler – Lip Augmentation">Dermal Filler – Lip Augmentation</option>
                        <option value="Dermal Filler – Cheek Enhancement">Dermal Filler – Cheek Enhancement</option>
                        <option value="Dermal Filler – Under Eye / Tear Trough">Dermal Filler – Under Eye / Tear Trough</option>
                        <option value="Sculptra Consultation">Sculptra Consultation</option>
                        <option value="Kybella / Fat Dissolving Injection">Kybella / Fat Dissolving Injection</option>
                    </optgroup>

                    <optgroup label="Body Contouring">
                        <option value="CoolSculpting / Cryolipolysis Consultation">CoolSculpting / Cryolipolysis Consultation</option>
                        <option value="Radiofrequency Body Tightening Consultation">Radiofrequency Body Tightening Consultation</option>
                        <option value="EMSculpt Consultation">EMSculpt Consultation</option>
                        <option value="Cellulite Treatment Inquiry">Cellulite Treatment Inquiry</option>
                    </optgroup>

                    <optgroup label="Hair Restoration">
                        <option value="PRP Hair Restoration Consultation">PRP Hair Restoration Consultation</option>
                        <option value="Laser Hair Therapy Inquiry">Laser Hair Therapy Inquiry</option>
                        <option value="Hair Transplant Pre-Consultation">Hair Transplant Pre-Consultation</option>
                    </optgroup>

                    <optgroup label="Pre-Treatment Guidance">
                        <option value="Preparing for Laser Hair Removal">Preparing for Laser Hair Removal</option>
                        <option value="Preparing for Botox / Fillers">Preparing for Botox / Fillers</option>
                        <option value="Preparing for Chemical Peel">Preparing for Chemical Peel</option>
                        <option value="Preparing for Microneedling">Preparing for Microneedling</option>
                    </optgroup>

                    <optgroup label="Post-Treatment Aftercare">
                        <option value="Aftercare for Botox">Aftercare for Botox</option>
                        <option value="Aftercare for Dermal Fillers">Aftercare for Dermal Fillers</option>
                        <option value="Aftercare for Chemical Peel">Aftercare for Chemical Peel</option>
                        <option value="Aftercare for Laser Hair Removal">Aftercare for Laser Hair Removal</option>
                        <option value="Aftercare for Microneedling">Aftercare for Microneedling</option>
                        <option value="Aftercare for CoolSculpting">Aftercare for CoolSculpting</option>
                    </optgroup>

                    <optgroup label="Medical Disclaimers / Escalations">
                        <option value="Adverse Reaction Report">Adverse Reaction Report</option>
                        <option value="Urgent Post-Treatment Concern">Urgent Post-Treatment Concern</option>
                        <option value="Pregnancy/Breastfeeding Treatment Inquiry">Pregnancy/Breastfeeding Treatment Inquiry</option>
                        <option value="Allergies & Contraindications Discussion">Allergies & Contraindications Discussion</option>
                    </optgroup>
                    </select>

                </label>

                <label>
                    New Customer?
                    <select
                    value={newCustomer}
                    onChange={(e) => setNewCustomer(e.target.value)}
                    >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                    </select>
                </label>
                </div>

                {/* New line for Start button */}
                <div className="start-button-container">
                <button className="primary-button">Start Mock Training</button>
                </div>

                {/* Chat Section */}
                <div className="chat-section">
                <div className="chatbot-container">
                    <ChatbotWidget clinicId="demo-clinic-id" />
                </div>
                </div>

                {/* Save Button */}
                <div className="save-section">
                <button className="primary-button">Save</button>
                </div>
            </>
            )}


        <hr className="mock-training-line" />
  
          {/* Training History Section */}
          <div className="section-header">
            <button
              className="section-button"
              onClick={() => setShowHistorySection(!showHistorySection)}
            >
              Training History {showHistorySection ? "▼" : "▲"}
            </button>
          </div>
  
          {showHistorySection && (
            <>
              <div className="filter-section">
                <select>
                  <option>Scenario</option>
                </select>
                <select>
                  <option>Customer Type</option>
                </select>
                <input type="text" placeholder="Keywords" />
              </div>
  
              {/* Table */}
              <table className="history-table">
                <thead>
                  <tr>
                    <th>Scenario</th>
                    <th>Customer Type</th>
                    <th>Date</th>
                    <th>Score</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {trainingHistory.map((row, i) => (
                    <tr key={i}>
                      <td>{row.scenario}</td>
                      <td>{row.customerType}</td>
                      <td>{row.date}</td>
                      <td>{"⭐".repeat(row.score)}</td>
                      <td>{row.status}</td>
                      <td>
                        <button className="link-button">View Chat</button>
                        <button className="link-button">Re-Test</button>
                        <button className="link-button">Feedback</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </div>
    );
  }